import React, { useEffect, useState } from 'react';

import { Link } from '@uhg-abyss/web/ui/Link';
import { useSelector } from 'react-redux';

import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import type { RootState } from '../../store/AppStore';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Box } from '@uhg-abyss/web/ui/Box';

import { V1SubNavigationMenu as SubNavigationMenu } from '@uhg-abyss/web/ui/SubNavigationMenu';
import { ErrorWarningPageHelp } from '@src/components/HelpPages/ErrorWarningPageHelp';
import { FieldChangeSummaryHelp } from './FieldChangeSummary';
import { EEMSDashboard } from './EEMSDashboard';
import { ProcStatHelp } from './ProcStatHelp';
import { Search } from './Search';
import { Download } from './Download';
import { AllTransFieldDef } from './AllTransFieldDef';
import { AddTranFieldDef } from './AddTranFieldDef';
import { NoChangeFieldDef } from './NoChangeFieldDef';
import { EligAnalystFieldDef } from './EligAnalystFieldDef';
import { CustCorrecFiledDef } from './CustCorrecFiledDef';
import { AutoCancelFieldDef } from './AutoCancelFieldDef';
import { Disclaimer } from './Disclaimer';
const ContentMain = ({ type }) => {
  const [reportState, setReportState] = useState(type);
  const contentStyle: React.CSSProperties = {
    // textAlign: 'left',
    marginLeft: '0px',
    marginBottom: '0px',
  };
  useEffect(() => {
    if (type != undefined) {
      setReportState(type);
    }
  }, [type]);

  const handlePageChange = (page) => {
    setReportState(page);
  };
  switch (reportState) {
    case 'Welcome': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>
              Welcome to the Electronic Eligibility Management System Online
              Help
            </h4>
            <br />

            <p>
              To begin, please select one of the items in the Table of Contents
            </p>
            <img src="/helpImage.jpg" />
          </div>
        </Box>
      );
    }
    case 'Intro': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>
              Welcome To the Electronic Eligibility Management System Online
              Help
            </h4>
            <br />

            <p>
              This online help tool is designed to assist you with the
              instructions needed to complete your tasks in the Electronic
              Eligibility Management System Online Application. Click the Help
              button to access Online Help. This opens the help designed for
              that page, and allows you to view all help topics. The Table of
              Contents to the left displays several books, such as Welcome and
              Logging On. The online help will open in a new window. Move back
              and forth between the help and the Electronic Eligibility
              Management System by using either the Alt+Tab keys or by clicking
              the icons on your task bar at the bottom of the screen. If you are
              looking for a particular piece of information, you can click the
              Index tab to search for a keyword. You can also use the Search
              button to search through Online Help to find a particular piece of
              information.
            </p>
          </div>
        </Box>
      );
    }
    case 'Login': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>Logging On</h4>
            <br />

            <p>
              Log onto the Electronic Eligibility Management System using the
              following steps:
            </p>
            <br />
            <p>1. Launch your web browser (e.g. Internet Explorer). </p>
            <br />
            <p>
              2. Type the URL in the Address field as follows:
              https://www.EmployereServices.com
            </p>
            <br />
            <p>3. Enter your User ID and Password.</p>
            <br />
            <p>4.Click Login or press Enter.</p>
            <br />
            <p>
              5. Click the Enrollment navigation bar option The Enrollment menu
              will be displayed.
            </p>
            <br />
            <p>6. Click on the Electronic File menu option. </p>
            <br />
            <p>
              Once you have successfully logged onto the Electronic Eligibility
              Management System the{' '}
              <Link onClick={() => handlePageChange('EEMS Home')}>
                Electronic Eligibility Management System Home Page
              </Link>{' '}
              is displayed where you may read announcements, view the status of
              your files, and access electronic eligibility reports.
            </p>
          </div>
        </Box>
      );
    }
    case 'Logout': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>Logging Out</h4>
            <br />

            <p>
              To log out of the system, click the Logout button from any screen
              in the Electronic Eligibility Management System.
            </p>
          </div>
        </Box>
      );
    }
    case 'EEMS Home': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <br />
            <h4>Electronic Eligibility Management System Home</h4>
            <br />
            <p>
              Once you have successfully logged onto the Electronic Eligibility
              Management System, the Electronic Eligibility Management System
              Home page is displayed where you may read anouncements, view the
              status of your files, and access electronic eligibility reports.
            </p>
            <br />
            <p>
              <Link onClick={() => handlePageChange('EEMS Home Dashboard')}>
                The Electronic Eligibility Management System Dashboard
              </Link>{' '}
              lists all the files that correlate with the User ID and Password
              entered at logon.
            </p>
            <br />
            <p>
              If no Customer Submission Names are associated with the User ID
              and you are currently sending electronic eligibility files to this
              system, please contact your Electronic Eligibility Analyst for
              assistance in getting access to your processing results. If you do
              not currently send electronic eligibility files to this system but
              are interested in doing so, please call your account manager for
              details on this electronic eligibility tool.
            </p>
          </div>
        </Box>
      );
    }
    case 'EEMS Home Dashboard': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <br />
            <h4>Electronic Eligibility Management System Home</h4>

            <br />
            <p>
              <EEMSDashboard />
            </p>
          </div>
        </Box>
      );
    }
    case 'ADD': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>Add Transactions</h4>
            <br />

            <p>
              The Add Transactions screen displays all successful add
              transactions. The Electronic Eligibility Management System will
              direct you to the Search screen when the rows returned exceeds a
              defined # of rows. Please see the{' '}
              <Link onClick={() => handlePageChange('Search')}>
                Search Page
              </Link>{' '}
              for more information.
            </p>
            <br />

            <p>
              Once data has been retrieved based on the criteria entered the Add
              Transactions screen displays all successful add transactions.
            </p>
            <br />
            <p>
              <mark>
                <b>Note: </b>
                <Link onClick={() => handlePageChange('Download')}>
                  Download
                </Link>{' '}
                and print capabilities are available by selecting the
                appropriate button.
              </mark>
            </p>
            <br />
            <p>
              The screen has the option to add both a primary and secondary
              sort. The primary and secondary sort options include: Type,
              Warning Name, File Processing Date, Severity, Employee ID,
              Relationship Code and Name.
            </p>
            <br />
            <p>
              For CSP, primary and secondary sort options include:
              <b>
                {' '}
                Severity, Subscriber ID, Medicaid ID, Name, Plan ID, Type ,
                Warning Name, Data Field.
              </b>
            </p>
            <br />
            <b>
              <p>To sort the records, complete the following:</p>
              <br />
              <p>
                1. Click the drop-down arrow located to the right of Primary
                Sort.{' '}
              </p>
              <br />
              <p>
                2.Locate and highlight the sort options you would like to use.{' '}
              </p>
              <br />
              <p>
                3.To add a secondary sort, click the drop-down arrow located to
                the right of Secondary Sort.
              </p>
              <br />
              <p>
                4.Select the field for which you would like a secondary sort.
              </p>
              <br />
              <p>5.Click Sort.</p>
            </b>
            <br />
            <p>
              Note: Download and print capabilities are available by selecting
              the Download button.
            </p>
            <br />
            <p>
              <Link onClick={() => handlePageChange('AddTranFieldDef')}>
                Field Definitions
              </Link>
            </p>
            <br />
            <p>
              <b>
                <mark>
                  Note: By selecting the Page Setting link, you can customize
                  how many records are displayed on this page. The Page will
                  also show the total number of adds displayed and the total
                  number of adds processed in the following format: Rows
                  Returned: ## For ## Total Adds.
                </mark>
              </b>
            </p>
          </div>
        </Box>
      );
    }
    case 'CHG': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>Change Transactions</h4>
            <br />

            <p>
              The Change Transactions screen displays all successful change
              transactions. Electronic Eligibility Management System will direct
              you to the Search screen when the rows returned exceeds a defined
              # of rows. Please see the
              <Link onClick={() => handlePageChange('Search')}>
                {' '}
                Search Page
              </Link>{' '}
              for more information.
            </p>
            <br />

            <p>
              Once data has been retrieved based on the criteria entered, the
              Change Transaction screen displays all successful Change
              transactions.
            </p>
            <br />

            <p>
              The screen has the option to add both primary and secondary sorts.
              The primary and secondary sort options include:{' '}
              <b>
                Type, Warning Name, File Processing Date, Severity, Employee ID,
                Relationship Code and Name.
              </b>
            </p>
            <br />
            <p>
              For CSP, primary and secondary sort options include:
              <b>
                {' '}
                Severity, Subscriber ID, Medicaid ID, Medicare ID(Medicare
                only), Name, Plan ID, Type, Warning Name ,Data Field.
              </b>
            </p>
            <br />
            <b>
              <p>To sort the records, complete the following:</p>
              <br />
              <p>
                1. Click the drop-down arrow located to the right of Primary
                Sort.{' '}
              </p>
              <br />
              <p>
                2.Locate and highlight the sort options you would like to use.{' '}
              </p>
              <br />
              <p>
                3.To add a secondary sort, click the drop-down arrow located to
                the right of Secondary Sort.
              </p>
              <br />
              <p>
                4.Select the field for which you would like a secondary sort.
              </p>
              <br />
              <p>5.Click Sort.</p>
            </b>
            <br />
            <p>
              <mark>
                Note: Download and print capabilities are available by selecting
                the Download button.
              </mark>
            </p>
            <br />
          </div>
        </Box>
      );
    }
    case 'NCH':
    case 'PROR':
    case 'PCPI': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>No Change Transactions</h4>
            <br />

            <p>
              The No Change Transactions screen displays all no change
              (bypassed) transactions. The Electronic Eligibility Management
              System will direct you to the Search screen when the rows returned
              exceeds a defined # of rows.
            </p>
            <br />

            <p>
              The screen has the option to add both a primary and secondary
              sort. The primary and secondary sort options include:
              <b>
                Type, Warning Name, File Processing Date, Severity, Employee ID,
                Relationship Code and Name.
              </b>
            </p>
            <br />
            <p>
              For CSP, primary and secondary sort options include:
              <b>
                {' '}
                Severity, Subscriber ID, Medicaid ID, Medicare ID(Medicare
                only), Name, Plan ID, Type, Warning Name ,Data Field.
              </b>
            </p>
            <br />

            <p>
              <mark>
                Note: Download and print capabilities are available by selecting
                the appropriate button.
              </mark>
            </p>
            <br />
            <p>
              <Link onClick={() => handlePageChange('NoChangeTranFieldDef')}>
                Field Definitions
              </Link>
            </p>
          </div>
        </Box>
      );
    }

    case 'ENW': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>Error and Warning Summary</h4>
            <br />

            <p>
              <ErrorWarningPageHelp />
            </p>
          </div>
        </Box>
      );
    }
    case 'AT': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>All Transactions</h4>
            <br />

            <p>
              The All Transactions screen displays all add, change, no change,
              and terms submitted/auto-cancel transactions that were successful
              or had errors or warnings. This page may be accessed from the link
              on the Processing Statistics page. The Electronic Eligibility
              Management System will direct you to the Search screen when the
              rows returned exceeds a defined # of rows. Please see the{' '}
              <Link onClick={() => handlePageChange('Search')}>
                Search Page
              </Link>
              for more information.
            </p>
            <br />
            <p>
              <mark>
                <b>Note:</b> All authenticated users are able to view All
                Transactions via the Electronic Eligibility Management System
                for all Customer Submission Names for which they have authorized
                security access.
              </mark>
            </p>
            <br />
            <p>
              The screen has the option to add both a primary and secondary
              sort. The primary and secondary sort options include:{' '}
              <b>
                Type, Error Name, Status, Severity, Employee ID, Relationship
                Code, and Name.
              </b>
            </p>
            <br />
            <p>
              For CSP, primary and secondary sort options include:Severity,
              Subscriber ID, Medicaid ID, Medicare ID(Medicare only), Name, Plan
              ID, Type, Warning Name ,Data Field.
            </p>
            <br />
            <p>To sort the records, complete the following:</p>
            <br />
            <p>
              1. Click the drop-down arrow located to the right of Primary Sort.{' '}
            </p>
            <br />
            <p>
              2.Locate and highlight the sort options you would like to use.{' '}
            </p>
            <br />
            <p>
              3.To add a secondary sort, click the drop-down arrow located to
              the right of Secondary Sort.
            </p>
            <br />
            <p>4.Select the field for which you would like a secondary sort.</p>
            <br />
            <p>5.Click Sort.</p>
            <br />
            <p>
              <b>
                Note:{' '}
                <Link onClick={() => handlePageChange('Download')}>
                  Download
                </Link>{' '}
                and print capabilities are available by selecting the Download
                button.
              </b>
            </p>
            <br />
            <p>
              <Link onClick={() => handlePageChange('AllTransFieldDef')}>
                Field Definitions
              </Link>
            </p>
            <br />
            <p>
              <mark>
                <b>
                  Note: By selecting the Page Setting link, you can customize
                  how many records are displayed on this page. The Page will
                  also show the total number of transactions displayed and the
                  total number of transactions processed in the following
                  format: Rows Returned: ## Resulting From ## Total
                  Transactions.
                </b>
              </mark>
            </p>
          </div>
        </Box>
      );
    }
    case 'TRM': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>Terms Submitted /Auto - Cancel Transactions</h4>
            <br />

            <p>
              The Terms Submitted / Auto-Cancel screen displays all successful
              terminations and auto-cancel transactions. The Electronic
              Eligibility Management System will direct you to the Search screen
              when the rows returned exceeds a defined # of rows.
            </p>

            <br />
            <p>
              The screen has the option to add both a primary and secondary
              sort. The primary and secondary sort options include:
              <b>
                Type, Warning Name, File Processing Date, Severity, Employee ID,
                Relationship Code, and Name.
              </b>
            </p>
            <br />
            <p>
              For CSP, primary and secondary sort options include:
              <b>
                Severity, Subscriber ID, Medicaid ID, Medicare ID (Medicare
                only), Name, Plan ID, Type, Warning Name ,Data Field. ID, Type,
                Warning Name ,Data Field.
              </b>
            </p>
            <br />
            <p>
              <Link onClick={() => handlePageChange('autoCancelFieldDef')}>
                Field Definitions
              </Link>
            </p>
            <br />

            <p>
              <mark>
                <b>Note:</b>{' '}
                <Link onClick={() => handlePageChange('Download')}>
                  {' '}
                  Download{' '}
                </Link>{' '}
                and print capabilities are available by selecting the Download
                button.
              </mark>
            </p>
            <br />
          </div>
        </Box>
      );
    }
    case 'EE': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>Customer Corrections Required</h4>
            <br />

            <p>
              The Customer Corrections Required screen is used to view all
              records, which were not processed due to errors. The Electronic
              Eligibility Management System will direct you to the Search screen
              when the rows returned exceeds a defined # of rows. Please see the{' '}
              <Link onClick={() => handlePageChange('Search')}>
                Search Page
              </Link>{' '}
              for more information.
            </p>

            <br />
            <p>
              <mark>
                <b>Note:</b> The Eligibility Analyst has the ability to assign
                additional errors and remove error records from the Customer
                Corrections Required page. The reassigned records will be
                highlighted in yellow. If you do not see an error in the
                Customer Error Index, check the{' '}
                <Link>Eligibility Analyst Error Index.</Link>
              </mark>
            </p>
            <br />
            <p>
              <mark>
                <b>Note:</b> All authenticated users are able to view Customer
                Corrections Required transactions via the Electronic Eligibility
                Management System for all Customer Submission Names for which
                they have authorized security access
              </mark>
            </p>
            <br />
            <p>
              <mark>
                <b>Note:</b> Please click to view{' '}
                <Link onClick={() => handlePageChange('Disclaimer')}>
                  Disclaimer.
                </Link>
              </mark>
            </p>

            <p>
              The screen has the option to add both a primary and secondary
              sort. The primary and secondary sort options include:
              <b>
                Type, Error Name, File Processing Date, Severity, Employee ID,
                Relationship Code and Name
              </b>
            </p>

            <br />
            <p>To sort the records, complete the following:</p>
            <br />
            <p>
              1. Click the drop-down arrow located to the right of Primary Sort.{' '}
            </p>
            <br />
            <p>
              2.Locate and highlight the sort options you would like to use.{' '}
            </p>
            <br />
            <p>
              3.To add a secondary sort, click the drop-down arrow located to
              the right of Secondary Sort.
            </p>
            <br />
            <p>4.Select the field for which you would like a secondary sort.</p>
            <br />
            <p>5.Click Sort.</p>
            <br />
            <p>
              <mark>
                <b>Note:</b>{' '}
                <Link onClick={() => handlePageChange('Download')}>
                  {' '}
                  Download{' '}
                </Link>{' '}
                and print capabilities are available by selecting the Download
                button.
              </mark>
            </p>
            <br />
            <p>
              <Link onClick={() => handlePageChange('custCorrecFieldDef')}>
                Field Definitions
              </Link>
            </p>
            <br />

            <p>
              <mark>
                <b>
                  Note: By selecting the Page Setting link, you can customize
                  how many records are displayed on this page. The Page will
                  also show the total number of transactions displayed and the
                  total number of transactions processed in the following
                  format: Rows Returned: ## Resulting From ## Total
                  Transactions.
                </b>
              </mark>
            </p>
            <br />
          </div>
        </Box>
      );
    }

    case 'FCH': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>Field Change Summary Report</h4>
            <br />

            <p>
              <FieldChangeSummaryHelp />
            </p>
          </div>
        </Box>
      );
    }
    case 'IE': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>Eligibility Analyst Corrections Required</h4>
            <br />

            <p>
              The Eligibility Analyst Corrections Required screen is used to
              view all records, which were not processed due to eligibility
              analyst assigned errors. This page may be accessed from the link
              on the Processing Statistics page. The Electronic Eligibility
              Management System will direct you to the Search screen when the
              rows returned exceeds a defined # of rows. Please see the{' '}
              <Link onClick={() => handlePageChange('Search')}>
                {' '}
                Search Page
              </Link>{' '}
              for more information.
            </p>
            <br />
            <p>
              <mark>
                <b>Note:</b> All authenticated users are able to view
                Eligibility Analyst Corrections Required transactions via the
                Electronic Eligibility Management System for all Customer
                Submission Names for which they have authorized security access.
              </mark>
            </p>
            <br />
            <p>
              The screen has the option to add both a primary and secondary
              sort. The primary and secondary sort options include:
              <b>
                Type, Error Name, File Processing Date, Severity, Employee ID,
                Relationship Code and Name
              </b>
            </p>
            <br />
            <p>
              For CSP, primary and secondary sort options include:{' '}
              <b>
                Severity, Subscriber ID Medicaid ID, Name, Plan ID, Type,
                Warning Name and Data Field.
              </b>
            </p>
            <br />
            <p>To sort the records, complete the following:</p>
            <br />
            <p>
              1. Click the drop-down arrow located to the right of Primary Sort.{' '}
            </p>
            <br />
            <p>
              2.Locate and highlight the sort options you would like to use.{' '}
            </p>
            <br />
            <p>
              3.To add a secondary sort, click the drop-down arrow located to
              the right of Secondary Sort.
            </p>
            <br />
            <p>4.Select the field for which you would like a secondary sort.</p>
            <br />
            <p>5.Click Sort.</p>
            <br />
            <p>
              <b>
                Note:{' '}
                <Link onClick={() => handlePageChange('Download')}>
                  Download
                </Link>{' '}
                capability is available by selecting the Download button.
              </b>
            </p>
            <br />
            <p>
              <Link onClick={() => handlePageChange('eligAnalFieldDef')}>
                Field Definitions
              </Link>
            </p>
            <br />
            <p>
              <mark>
                <b>
                  Note:By selecting the Page Setting link, you can customize how
                  many records are displayed on this page. The Page will also
                  show the total number of errors displayed and the total number
                  of errors in the file in the following format: Errors
                  Returned: ## For ## Total Errors.
                </b>
              </mark>
            </p>
          </div>
        </Box>
      );
    }

    case 'procStat': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>Processing Statistics</h4>
            <br />

            <p>
              <ProcStatHelp />
            </p>
          </div>
        </Box>
      );
    }
    case 'Search': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>Search</h4>
            <br />

            <p>
              <Search />
            </p>
          </div>
        </Box>
      );
    }
    case 'Download': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>Download</h4>
            <br />

            <p>
              <Download />
            </p>
          </div>
        </Box>
      );
    }
    case 'AddTranFieldDef': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>Add Transactions Field Definitions</h4>
            <br />

            <p>
              <AddTranFieldDef />
            </p>
          </div>
        </Box>
      );
    }

    case 'AllTransFieldDef': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>All Transactions Field Definitions</h4>
            <br />

            <p>
              <AllTransFieldDef />
            </p>
          </div>
        </Box>
      );
    }
    case 'NoChangeTranFieldDef': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>No Change Transactions Field Definitions</h4>
            <br />

            <p>
              <NoChangeFieldDef />
            </p>
          </div>
        </Box>
      );
    }
    case 'eligAnalFieldDef': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>Eligibility Analyst Corrections Required</h4>
            <br />

            <p>
              <EligAnalystFieldDef />
            </p>
          </div>
        </Box>
      );
    }
    case 'custCorrecFieldDef': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>Customer Corrections Required Field Definitions</h4>
            <br />

            <p>
              <CustCorrecFiledDef />
            </p>
          </div>
        </Box>
      );
    }
    case 'autoCancelFieldDef': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>Terms Submitted/Auto-Cancel Field Definitions</h4>
            <br />

            <p>
              <AutoCancelFieldDef />
            </p>
          </div>
        </Box>
      );
    }
    case 'Disclaimer': {
      return (
        <Box color="$web.semantic.color.text.content.primary-alt">
          <div style={contentStyle}>
            <h4>
              Disclaimer for the Electronic Eligibility Management System
              Screens
            </h4>
            <br />

            <p>
              <Disclaimer />
            </p>
          </div>
        </Box>
      );
    }
    default: {
      return null;
    }
  }
};

export const HelpMain: React.FC = () => {
  const { reportType } = useRouter().getRouteParams();
  const [pageType, setPageType] = useState('Welcome');
  var reportTypeValCurrent = useSelector(
    (state: RootState) => state.reportTypeVal.value
  );
  useEffect(() => {
    if (reportType != undefined && reportType?.length > 0) {
      setPageType(reportType);
    }
  }, []);
  useEffect(() => {
    if (reportTypeValCurrent) {
      setPageType(reportTypeValCurrent);
    }
  }, [reportTypeValCurrent]);

  //const router = useRouter();
  const navItems = [
    {
      title: 'Welcome',
      onClick: () => {
        setPageType('Welcome');
      },
      subItems: [
        {
          title: 'Welcome',

          onClick: () => {
            setPageType('Welcome');
          },
        },
        {
          title: 'Intro to Online Help',
          onClick: () => {
            setPageType('Intro');
          },
        },
      ],
    },
    {
      title: 'Logging in',
      onClick: () => {
        setPageType('Login');
      },
      subItems: [
        {
          title: 'Logging in',

          onClick: () => {
            setPageType('Login');
          },
        },
      ],
    },
    {
      title: 'Logging out',
      onClick: () => {
        setPageType('Logout');
      },
      subItems: [
        {
          title: 'Logging out',

          onClick: () => {
            setPageType('Logout');
          },
        },
      ],
    },
  ];

  return (
    <React.Fragment>
      {/*  <DrawerMenu
        menuItems={menuItems}
        isOpen={true}
        css={{
          'abyss-drawer-menu-wrapper': { height: '1500px' },
        }}
      /> */}
      <Layout.Group space={0} css={{ alignItems: 'top' }}>
        <div
          style={{
            display: 'flex',

            alignItems: 'flex-start',
          }}
        >
          <SubNavigationMenu
            navItems={navItems}
            position="left"
            css={{
              alignItems: 'top',
              '.abyss-sub-navigation-header-container': {
                position: 'relative',
              },
              '.abyss-sub-navigation-header-text::after': {
                content: '""',
                position: 'absolute',
                borderBottom:
                  '1px solid $web.semantic.color.border.content.secondary',
                width: '100%',
                left: 0,
                bottom: '-8px',
              },
            }}
          />
          <Box color="transparent" padding={0}>
            <ContentMain type={pageType} />
          </Box>
        </div>
      </Layout.Group>
    </React.Fragment>
  );
};
